<ng-container>
  <div class="solutions-container">
    <h1 [title]="'Our solutions' | trans" class="solutions-container-title">
      {{ 'Our solutions' | trans }}
    </h1>

    <div class="solution-items">
      @for (solution of solutions(); track solution.slug) {
        <solution-card [item]="solution" />
      }
    </div>
  </div>
</ng-container>
